<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), {
  color: "content-inverse",
  size: "md",
  background: "content-inverse",
});

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" background="transparent" viewBox="0 0 20 20">
    <rect width="20" height="20" rx="2" :class="colorClass" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.7069 5.29305C17.0974 5.68359 17.0974 6.31675 16.7068 6.70726L8.70634 14.707C8.51879 14.8946 8.26442 14.9999 7.9992 14.9999C7.73397 14.9999 7.47962 14.8945 7.2921 14.7069L3.29307 10.7072C2.90258 10.3166 2.90264 9.68344 3.2932 9.29295C3.68376 8.90246 4.31693 8.90252 4.70742 9.29308L7.99936 12.5856L15.2927 5.29298C15.6832 4.90248 16.3164 4.90251 16.7069 5.29305Z"
      fill="white"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
